import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import moment from 'moment';

import PageContainer from '../../components/layout/PageContainer';
import SignatureNeededSection from './components/SignatureNeededSection';
import AssignedClients from './components/AssignedClients';
import TPExpiringSection from './components/TPExpiringSection';
import ClientSNToReview from './components/ClientSNToReview';
import {
  btSupervisionActions,
  clientAssessmentActions,
  clientSupervisionActions,
  groupParentSupervisionActions,
  metricsActions,
  parentSupervisionActions,
  treatmentPlanActions,
  sessionActions,
} from '../../store';
import { API_DATE_FORMAT, SupervisionNoteStatus } from '../../constants';
import { TreatmentPlanStatus } from '../../components/layout/treatment-plan/constants/general';
import BCBASessionSection from './components/BCBASessionSection';

function BCBADashboard() {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    const params1 = { status: SupervisionNoteStatus.Started, action_required: true };
    const params2 = { status_id: 1, action_required: true };

    dispatch(treatmentPlanActions.updateState({ key: 'list', value: [] }));

    dispatch(
      clientAssessmentActions.getList({
        params: params1,
        getAccessTokenSilently,
      }),
    );
    dispatch(
      groupParentSupervisionActions.getList({
        params: params1,
        getAccessTokenSilently,
      }),
    );
    dispatch(clientSupervisionActions.getList({ params: params2, getAccessTokenSilently }));
    dispatch(parentSupervisionActions.getList({ params: params2, getAccessTokenSilently }));
    dispatch(btSupervisionActions.getList({ params: params2, getAccessTokenSilently }));
    dispatch(
      metricsActions.getSupervisionMetrics({
        getAccessTokenSilently,
        start: moment().startOf('month').format(API_DATE_FORMAT),
        end: moment().format(API_DATE_FORMAT),
        exclude_clients_meeting_csn_criteria: true,
      }),
    );

    dispatch(
      treatmentPlanActions.getTreatmentPlanByQuery({
        query: {
          status: [TreatmentPlanStatus.Started, TreatmentPlanStatus.Editing].join(','),
          expand: 'treatment_recommendation',
          action_required: true,
        },
        getAccessTokenSilently,
        skipCurrentTpChange: true,
      }),
    );
    dispatch(
      sessionActions.getList({
        getAccessTokenSilently,
        params: {
          endDate: moment().endOf('day'),
          startDate: moment().subtract(365, 'days').startOf('day'),
          include_participated_only: true,
        },
      }),
    );
  }, []);

  return (
    <PageContainer
      dataTestId="dashboardContainer"
      sx={{
        p: {
          xs: 2,
          sm: 3,
          md: 3,
          lg: 3,
          xl: 3,
        },
      }}
    >
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} sm={12} md={4}>
          <SignatureNeededSection />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TPExpiringSection />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ClientSNToReview />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4}>
          <BCBASessionSection />
        </Grid>
        <Grid item xs={12} sm={12} md={8}>
          <AssignedClients />
        </Grid>
      </Grid>
    </PageContainer>
  );
}

export default BCBADashboard;
